import * as yup from 'yup';
export default (data) =>
{
  let schema = yup.object().shape({
    firstName: yup.string().max(30).required(),
    lastName: yup.string().max(20).required(),
    phone: yup.string().max(14).required(),
    email: yup.string().max(60).email().required(),
    password: yup.string().required(),
    status: yup.boolean().optional().default(true),
    });

    try {
      schema.validateSync({...data});
      return {status: 'success', data: {...data, image: data.image}};
    } catch (error) {
      return {status: 'failure', message: error.errors[0]}
    }
}